import { toast } from './routedToast';

export {
  Bounce,
  collapseToast,
  cssTransition,
  Flip,
  Icons,
  Slide,
  ToastContainer,
  Zoom,
} from 'react-toastify';
export type {
  Id,
  ToastContainerProps,
  ToastContent,
  ToastOptions,
  ToastPosition,
  TypeOptions,
} from 'react-toastify';

export * from './alert';
export { setToastRouter, toast } from './routedToast';
export type { RoutedToast, ToastRoute, ToastRouter } from './routedToast';
export * from './Toasts';
export * from './undo';

/**
 * Show a notification for an unexpected error.
 */
export function toastUnexpectedError(err: Error, options: { prefix?: string } = {}) {
  console.error(options.prefix || '', err);
  const message = options.prefix ? `${options.prefix}: ${err.toString()}` : err.toString();
  toast(message, { type: 'error' });
}
